module.exports = __webpack_public_path__ + "static/media/6.94963bc6.png";